import { TripMessageRead } from 'src/common/external/bambi-api/bambiApi';

export function TripMessageSummaryContent({
  tripMessage,
}: {
  tripMessage: TripMessageRead;
}) {
  // The body of this message type is a URL, so render a link to it
  if (tripMessage.message_type === 'public-trip-portal') {
    return (
      <div>
        <a
          href={tripMessage.message.body}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="text-blue-500 underline"
        >
          {tripMessage.message.body}
        </a>
      </div>
    );
  }
  return <div>{tripMessage.message.body}</div>;
}
